import { Injectable } from '@angular/core';
import { HttpWrapperService } from '../common/http-wrapper/http-wrapper.service';
import { Observable } from 'rxjs';

import { IdNamePairViewModel } from '../../models/IdNamePairViewModel';

@Injectable()
export class IndustryApiService {
    constructor(private httpService: HttpWrapperService ) { }

    public getIndustries(): Observable<IdNamePairViewModel[]> {
        return this.httpService.get<IdNamePairViewModel[]>('/articles/industries');
    }
}
